import { render, staticRenderFns } from "./deleteDialog.vue?vue&type=template&id=12d0c138&scoped=true&"
import script from "./deleteDialog.vue?vue&type=script&lang=js&"
export * from "./deleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteDialog.vue?vue&type=style&index=0&id=12d0c138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0c138",
  null
  
)

export default component.exports